module.exports = __webpack_public_path__ + "img/P7.3070d8fd.jpg";